import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFaqs,
  fetchFaqsSuccess,
  fetchFaqsFailure,
} from "../slices/faqSlice";

function* fetchFaqsWorker() {
  try {
    const res = yield call(fetch, `${process.env.REACT_APP_API_URL}/v1/faqs`);
    const data = yield res.json();

    if (data?.data) {
      // ✅ filter + sort yahi kar do (component clean rahega)
      const activeFaqs = data.data
        .filter((faq) => faq.status === "active")
        .sort((a, b) => (a.orderby || 0) - (b.orderby || 0));

      yield put(fetchFaqsSuccess(activeFaqs));
    } else {
      yield put(fetchFaqsFailure("No FAQ data"));
    }
  } catch (error) {
    yield put(fetchFaqsFailure(error.message));
  }
}

export default function* faqSaga() {
  yield takeLatest(fetchFaqs.type, fetchFaqsWorker);
}
